import Vue from "vue";
import NProgress from "nprogress";
import Router from "vue-router";
import Home from "./views/Home.vue";
import LegendOtc from "./views/LegendOtc.vue";
import LegendPay from "./views/LegendPay.vue";

import "nprogress/nprogress.css";

Vue.use(Router);

let progressTimer: number | null = null;
// const scrollBehavior = (to:any, from:any, savedPosition:any) => {
//   if (savedPosition) {
//     // savedPosition is only available for popstate navigations.
//     return savedPosition;
//   } else {
//     const position:any = {};
//     // new navigation.
//     // scroll to anchor by returning the selector
//     if (to.hash) {
//       position.selector = to.hash;
//     }
//     // check if any matched route config has meta that requires scrolling to top
//     if (to.matched.some(m => m.meta.scrollToTop) ) {
//       // cords will be used if no selector is provided,
//       // or if the selector didn't match any element.
//       position.x = 0;
//       position.y = 0;
//     }
//     // if the returned position is falsy or an empty object,
//     // will retain current scroll position.
//     return position;
//   }
// };
const router = new Router({
  mode: "history",
  base: process.env.BASE_URL,
  routes: [
    {
      path: "/",
      name: "home",
      meta: { splash: "animate", background: "grid", header: "transparent" },
      component: Home
    },
    {
      path: "/legend-otc",
      name: "legend-otc",
      meta: { splash: "animate", background: "grid", header: "transparent" },
      component: LegendOtc
    },
    {
      path: "/legend-pay",
      name: "legend-pay",
      meta: { splash: "animate", background: "grid", header: "transparent" },
      component: LegendPay
    },
    {
      path: "/about",
      name: "about",
      meta: {
        splash: "animate",
        header: "light"
      },
      component: () =>
        import(/* webpackChunkName: "about" */ "./views/About.vue")
    },
    {
      path: "/media-kit",
      name: "media-kit",
      meta: {
        splash: "animate",
        header: "light"
      },
      component: () =>
        import(/* webpackChunkName: "media-kit" */ "./views/mediaKit/Index.vue")
    },
    {
      path: "/partner",
      name: "partner",
      meta: {
        header: "partner",
        footer: "hide"
      },
      component: () =>
        import(/* webpackChunkName: "partner" */ "./views/partner/Index.vue")
    },
    {
      path: "/partner/faq",
      name: "partner.faq",
      meta: {
        header: "partner",
        footer: "hide"
      },
      component: () =>
        import(/* webpackChunkName: "partner" */ "./views/partner/Faq.vue")
    },
    {
      path: "/developers",
      name: "developers",
      meta: {
        splash: "animate",
        background: "grid",
        header: "light"
      },
      component: () =>
        import(/* webpackChunkName: "developers" */ "./views/Developers.vue")
    },
    {
      path: "/services",
      name: "services",
      component: () =>
        import(/* webpackChunkName: "services" */ "./views/Services.vue")
    },
    {
      path: "/contact",
      name: "contact",
      meta: { background: "grid-upper", header: "dark", menu: "hide" },
      component: () =>
        import(/* webpackChunkName: "contact" */ "./views/Contact.vue")
    },
    {
      path: "/cases",
      name: "cases",
      meta: { splash: "animate", header: "light" },
      component: () =>
        import(/* webpackChunkName: "cases" */ "./views/Cases.vue")
    },
    {
      path: "/cases/:partner",
      name: "cases.detail",
      meta: { splash: "animate", header: "light" },
      component: () =>
        import(/* webpackChunkName: "cases" */ "./views/CaseDetails.vue"),
      props: true
    },
    {
      path: "/terms",
      name: "terms",
      meta: { background: "grid-upper", header: "dark" },
      component: () =>
        import(/* webpackChunkName: "terms" */ "./views/Terms.vue")
    },
    {
      path: "/policy",
      name: "policy",
      meta: { background: "grid-upper", header: "dark" },
      component: () =>
        import(/* webpackChunkName: "policy" */ "./views/Policy.vue")
    },
    {
      path: "/register",
      redirect: { name: "contact" }
    },
    {
      path: "/registercn",
      redirect: { name: "contact" }
    },
    {
      path: "/kyc/:lang?",
      name: "kyc",
      meta: {
        scrollToTop: true,
        splash: "animate",
        background: "grid-upper",
        footer: "light",
        header: "light"
      },
      props: route => {
        const { lang } = route.params;
        const {
          role = "",
          remote = "",
          code = "",
          state = 0,
          retry = 0,
          step = 0
        } = route.query;
        return {
          role,
          remote,
          lang,
          code,
          state: Number.parseInt(state as string),
          retry: Number.parseInt(retry as string),
          step: Number.parseInt(step as string)
        };
      },
      component: () => import(/* webpackChunkName: "kyc" */ "./views/Kyc.vue")
    },
    {
      path: "*",
      name: "blank",
      component: () =>
        import(/* webpackChunkName: "blank" */ "./views/Blank.vue")
    }
  ],
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition;
    } else {
      const position: any = {};
      if (to.hash) {
        position.selector = to.hash;
      } else if (to.matched.some(m => m.meta.scrollToTop)) {
        position.x = 0;
        position.y = 0;
      }
      return position;
    }
  }
});

router.beforeResolve((to, from, next) => {
  if (progressTimer) {
    clearTimeout(progressTimer);
  }
  progressTimer = window.setTimeout(NProgress.start, 100);
  return next();
});

router.afterEach(() => {
  if (progressTimer) {
    clearTimeout(progressTimer);
  }
  NProgress.done();
});

export default router;
